import i18next from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"
import ja from "../../locale/ja/strings.json"

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "ja",
    lng: "ja",
    resources: {
      ja: {
        translation: ja,
      },
    },
    interpolation: {
      escapeValue: false,
    },
  })
  .catch()

export default i18next
